import React from 'react';
import {Context} from "../index";
import CameraService from "../services/cameraService";
import Loader from "../ui/loader/loader";
import Cart from "../ui/cart/cart";
import Container from "../ui/container/container";
import BottomMenu from "../ui/menu/bottomMenu";
import Bar from "../ui/bar/bar";
import Button from "../ui/button/button";
import {useLocation} from "react-router-dom";
import {adminSettingMenu} from "../routes/menu";
import {observer} from "mobx-react-lite";
import Moment from "react-moment";
import jwt_decode from "jwt-decode";

const CameraComponent = observer(() => {
    const {camera} = React.useContext(Context);
    const location = useLocation();

    const [error, setError] = React.useState('');
    const [loader, setLoader] = React.useState(true);

    React.useEffect(() => {
        CameraService.getCameras()
            .then(data => {
                camera.setCameras(data);
            })
            .catch(err => {
                setError(err.response.data.message);
            })
            .finally(() => {
                setLoader(false);
            })
    }, []);

    if (loader){
        return <Loader/>
    }

    return (
        <div>
            {
                error && <p>{error}</p>
            }
            <Bar>
                <ul>
                    {
                        localStorage.getItem('token') && jwt_decode(localStorage.getItem('token')).roleId !== 5
                        ?
                            adminSettingMenu.map(
                                item => <li key={item.id} className={location.pathname === item.url && 'active'}>
                                    <Button to={item.url} variant={'linkText'}>{item.title}</Button>
                                </li>
                            )
                        :
                            <li className={'active'}>
                                <Button to={'/cameras'} variant={'linkText'}>Камеры</Button>
                            </li>
                    }
                </ul>
            </Bar>
            <Container
                variant={'leftBar'}
            >
                <div className="flex fw-wrap">
                    {
                        camera.isCameras.rows.map(
                            item =>
                                <Cart
                                    key={item.id}
                                    variant={'link'}
                                    type={'button'}
                                    buttonText={'Перейти'}
                                    to={'/cameras/' + item.id}
                                >
                                    <div className="name">
                                        <span>Имя:</span>
                                        <p>{item.name}</p>
                                    </div>
                                    <div className="name">
                                        <span>Локация:</span>
                                        <p>{item.location.name}</p>
                                    </div>
                                    <div className="role">
                                        <span>Добавлен(а):</span>
                                        <p><Moment format={'YYYY.MM.DD HH:mm:ss'}>{item.createdAt}</Moment></p>
                                    </div>
                                </Cart>
                        )
                    }
                </div>
            </Container>
            <BottomMenu>
                <div className="count">
                    <span>Всего: </span><p>{camera.isCameras.count}</p>
                </div>
                <div className="addButton"></div>
            </BottomMenu>
        </div>
    );
});

export default CameraComponent;